var inboxApp = angular.module('inboxApp', [
  'ui.bootstrap',
  'configService',
  'sharedServices',
  'sharedFilters'
]);

inboxApp.config(function ($interpolateProvider) {
  $interpolateProvider.startSymbol('{[');
  $interpolateProvider.endSymbol(']}');
});
inboxApp.controller('inboxController', [
  '$scope',
  'inboxData',
  'sendUserMsg',
  'getThreadMsg',
  'config',
  'EncryptedLocalStorage',
  'getUserInfo',
  'getCollabs',
  'addUserMsg',
  function (
    $scope,
    inboxData,
    sendUserMsg,
    getThreadMsg,
    config,
    EncryptedLocalStorage,
    getUserInfo,
    getCollabs,
    addUserMsg
  ) {
    config.token = localStorage.getItem('token');
    // $scope.inbox = {};
    $scope.emptyInbox = false;
    $scope.onsubmit = false;
    $scope.S3_URL = config.S3_URL;
    $scope.inbox = new inboxData(config.token);
    $scope.inbox.nextPage();
    $('#wmg-messenger-box').perfectScrollbar();
    $('#msg-thread').perfectScrollbar();
    if ($scope.inbox) {
      $scope.inbox.hideText = false;
    } else {
      $scope.inbox.hideText = true;
    }
    var callThreadMsg = function (thread_id) {
      getCollabs(config.token, $scope.inbox.wedding_code).success(function (
        data
      ) {
        $scope.inbox.collabList = data.data;
      });
      getThreadMsg(config.token, thread_id, '0', '10').success(function (data) {
        $scope.inbox.threadMsg = data.data;
        $scope.inbox.threadUsers = data.users;
        $scope.inbox.threadMsg = $scope.inbox.threadMsg.reverse();
        for (var i = 0; i < data.users.length; i++) {
          if (data.users[i].role === 'vendor') {
            $scope.inbox.currentThreadName = data.users[i].name;
            $scope.inbox.receiver_id = data.users[i].member_id;
          }
        }
        //$scope.inbox.currentThreadName = data.users[0].name;
        for (var i = 0; i < $scope.inbox.threadMsg.length; i++) {
          for (var j = 0; j < data.users.length; j++) {
            if (
              $scope.inbox.threadMsg[i].member_id === data.users[j].member_id
            ) {
              $scope.inbox.threadMsg[i].name = data.users[j].name;
              $scope.inbox.threadMsg[i].profile_pic_url =
                data.users[j].profile_pic_url;
              $scope.inbox.threadMsg[i].original_pic_url =
                data.users[j].original_pic_url;
              $scope.inbox.threadMsg[i].thumb_status =
                data.users[j].thumb_status;
            }
          }
        }
        var collabList = angular.copy($scope.inbox.collabList);
        // will affect the original collablist array , this loop removes the users already in chat
        if (collabList) {
          for (var i = 0; i < collabList.length; i++) {
            for (var j = 0; j < $scope.inbox.threadUsers.length; j++) {
              if (
                collabList[i].user.id == $scope.inbox.threadUsers[j].member_id
              ) {
                $scope.inbox.collabList = $scope.inbox.collabList.filter(
                  function (data) {
                    return (
                      data.user.id != $scope.inbox.threadUsers[j].member_id
                    );
                  }
                );
              }
            }
          }
        }
      });
    };

    // navprofile.js sends the wedding id onload
    $('#navApp').on('sendWeddingId', function (event, code) {
      $scope.inbox.wedding_code = code;
      $scope.inbox.userData = $scope.inbox.items;
      if (!$scope.inbox.userData || !$scope.inbox.userData.length) {
        $scope.emptyInbox = true;
      }
      if ($scope.inbox.userData) {
        var length = $scope.inbox.userData.length;
        $scope.inbox.thread_id = $scope.inbox.userData[length - 1].thread_id;
        callThreadMsg($scope.inbox.thread_id);
      }
    });

    $('#wmg-messenger-box').on('scroll', function () {
      if (
        $(this).scrollTop() + $(this).innerHeight() + 250 >=
        $(this)[0].scrollHeight
      ) {
        $scope.inbox.nextPage();
      }
    });

    $scope.dynamicPopover = {
      content: 'Hello, World!',
      templateUrl: '../../html/myPopoverTemplate.html',
      title: 'Title'
    };
    $scope.inviteinbox = function (id) {
      addUserMsg(config.token, $scope.inbox.thread_id, id).success(function () {
        for (var i = 0; i < $scope.inbox.userData.length; i++) {
          if ($scope.inbox.userData[i].thread_id == $scope.inbox.thread_id) {
            $scope.inbox.userData[i].users.length++;
          }
        }
        $scope.inbox.collabList = $scope.inbox.collabList.filter(function (
          data
        ) {
          return data.user.member_id != id;
        });
      });
    };

    $scope.sendMsg = function () {
      if ($scope.inbox.replyMsg == '' || !$scope.inbox.replyMsg) {
      } else {
        $scope.onsubmit = true;
        sendUserMsg(
          config.token,
          $scope.inbox.thread_id,
          $scope.inbox.replyMsg
        ).success(function (data) {
          $scope.inbox.replyMsg = '';
          // $('.inbox-reply-textarea').val('');
          callThreadMsg($scope.inbox.thread_id);
          $scope.onsubmit = false;
          var scolled = 0;
          $('#msg-thread').animate({
            scrollTop: $('#msg-thread').get(0).scrollHeight
          });
        });
      }
    };

    $scope.messageThread = function (thread_id) {
      $scope.inbox.thread_id = thread_id;
      callThreadMsg(thread_id);
      $('#msgs-div-empty').addClass('ng-hide');
      $('#messages-div').removeClass('ng-hide');
      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        $('#wmg-user-inbox-left').css('display', 'none');
        $('.wmg-messenger-right').css('display', 'block');
      }
      // code to scroll to the top when a new thread is opened
      var scrolled = 0;
      scrolled = scrolled - 100;
      $('#msg-thread').animate({
        scrollTop: scrolled
      });
    };
    $scope.showInbox = function () {
      $('.wmg-messenger-right').css('display', 'none');
      $('#wmg-user-inbox-left').css('display', 'block');
    };
  }
]);
function parseDateUTC(input) {
  var reg = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
  var parts = reg.exec(input);
  return parts
    ? new Date(
        Date.UTC(parts[1], parts[2] - 1, parts[3], parts[4], parts[5], parts[6])
      )
    : null;
}
inboxApp.filter('extractDate', function ($filter) {
  var suffixes = ['th', 'st', 'nd', 'rd'];
  return function (input, format) {
    input = parseDateUTC(input);
    var dtfilter = $filter('date')(input, format);
    var day = parseInt($filter('date')(input, 'dd'));
    var relevantDigits = day < 30 ? day % 20 : day % 30;
    var suffix = relevantDigits <= 3 ? suffixes[relevantDigits] : suffixes[0];
    return dtfilter.replace('oo', suffix);
    //return dtfilter+suffix;
  };
});
angular.bootstrap(document.getElementById('inboxApp'), ['inboxApp']);
